import { render, staticRenderFns } from "./LedgerFormatOptionsPanel.vue?vue&type=template&id=5861d436&scoped=true&"
import script from "./LedgerFormatOptionsPanel.vue?vue&type=script&lang=js&"
export * from "./LedgerFormatOptionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./LedgerFormatOptionsPanel.vue?vue&type=style&index=0&id=5861d436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861d436",
  null
  
)

export default component.exports